import { render } from "./MemebershipMessageSentNotification.vue?vue&type=template&id=d6c94ba2"
import script from "./MemebershipMessageSentNotification.vue?vue&type=script&lang=js"
export * from "./MemebershipMessageSentNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__